$(window).on("load", function() {
	// ===== Check if IE10 =====
	if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
        $('body').addClass('IE10-browser');
        $('body').append('<p class=chromeframe>Your browser is <em>ancient!</em> <a href="https://browsehappy.com/"> Upgrade to a different browser</a> or <a href="https://support.google.com/chrome/answer/95346?hl=en">install Google Chrome </a> to experience this site.</p>');
    }
});